import { DffOprindeligAktuelVaerdi } from "@dffedb/util";

export class DbTaellevaerkAflaesning {
    public historiskAflaesning: string;
    public enhedType: string;
    public aflaesning: DffOprindeligAktuelVaerdi<string>;
}
